
    import Vue from "vue";
    import { Prop, Watch, Component } from "vue-property-decorator";
    import { mask } from 'vue-the-mask';
import { validarCuit } from '@/__env/pluggins/event-bus';

    @Component( {
        name: "Componente",
        directives: { mask },
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {
        //Mascara: string = '##-########-#';
        Mascara: string = '###########';

        @Prop( { type: String } )
        public value: string;

        @Prop( { type: Boolean } )
        public disabled: boolean;

        @Prop( { type: Boolean } )
        public readonly: boolean;

        Visible: boolean = true;

        @Watch( 'value', { immediate: true } )
        onIndex()
        {
            this.Selected = this.value;
        }

        public selected: string | null = null;
        public get Selected(): string | null
        {
            return this.selected;
        }
        public set Selected( x: string | null )
        {
            this.selected = x;
            this.$emit( 'input', this.Selected?.replace( '-', '' ) );
        }

        public async onLostFocus( event: any )
        {
            if ( this.Selected )
                this.Error = this.Selected.length != 11;

            if ( !this.Error && this.Selected )
                this.Error = !validarCuit( this.Selected );

            if ( !this.Error && this.Selected )
            {
                this.Mascara = '##-########-#';
                this.Selected = this.Selected.formatCUIT();
            } else
            {
                this.Selected = '';
            }
        }

        public async onGotFocus( event: any )
        {
            this.Error = false;
            this.Mascara = '###########';
            this.Selected = this.Selected.replace( '-', '' );
        }

        public Error: boolean = false;

    }
